import React from 'react';
import RawHtml from '../HelperComponents/RawHtml';

const Resources = () => {
  return <RawHtml page={'resource'} />;
};

export default Resources;
